// extracted by mini-css-extract-plugin
export var blue = "styles-module--blue--cad6c";
export var click = "styles-module--click--3f03b";
export var green = "styles-module--green--39244";
export var image = "styles-module--image--a548a";
export var inner = "styles-module--inner--ebe4e";
export var noBorder = "styles-module--noBorder--fc7f8";
export var partial = "styles-module--partial--cc7f9";
export var shadow = "styles-module--shadow--52438";
export var wrapper = "styles-module--wrapper--1b4b7";